import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InvoiceCashReceiptCaptureTableModel } from 'src/app/models/tables/wallet/invoice-cash-receipt-capture-table.model';
import { InvoiceSelectionTableModel } from 'src/app/models/tables/wallet/invoice-selection-table.model';
import { CashReceiptModel } from 'src/app/models/wallet/cash-receipt.model';
import { InvoiceCashReceiptModel } from 'src/app/models/wallet/invoice-cash-receipt.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { InvoiceCashReceiptService } from 'src/app/services/wallet/invoice-cash-receipt.service';
import Swal from 'sweetalert2';
import { InvoiceCashReceiptRetentionModalComponent } from '../../invoice-cash-receipt-retention/invoice-cash-receipt-retention-modal/invoice-cash-receipt-retention-modal.component';

@Component({
  selector: 'app-invoice-cash-receipt',
  templateUrl: './invoice-cash-receipt.component.html',
  styleUrls: ['./invoice-cash-receipt.component.scss'],
  standalone: false
})
export class InvoiceCashReceiptComponent implements OnInit, OnChanges {

  @ViewChild('invoiceSelection') invoiceSelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('taxesModal') taxesModalComponent?: CustomModalComponent | null = null;

  @Input() cashReceiptModel: CashReceiptModel = new CashReceiptModel();
  @Input() disabledDetail: boolean = false;
  @Input() isChargeAccount: boolean = false;
  @Input() permissionUpdatable: boolean = false;
  @Output() quantityDetails = new EventEmitter<number>();

  ascendant: boolean = true;
  ascendantInvoice: boolean = true;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  columnSortInvoice: string | null = null;
  detailData: PagedResponseModel<InvoiceCashReceiptCaptureTableModel> = new PagedResponseModel<InvoiceCashReceiptCaptureTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  dataInvoice: PagedResponseModel<InvoiceSelectionTableModel> = new PagedResponseModel<InvoiceSelectionTableModel>();
  filters: ColumnResponseModel[] = [];
  filtersInvoice: ColumnResponseModel[] = [];
  headerInvoice: ColumnResponseModel[] = [];
  inputsForInvoicesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: false,
    isMultipleSelect: true,
    filters: [],
  });
  inputsForTaxesModals$ = new BehaviorSubject<any>({
    invoiceCashReceiptId: 0,
    permissionUpdatable: false,
    disabledForm: false
  });
  invoiceCashReceiptModel: InvoiceCashReceiptModel = new InvoiceCashReceiptModel();
  invoiceCashReceiptId: number = 0;
  isFormView: boolean = false;
  limit: number = 10;
  limitInvoice: number = 10;
  output$ = new Subject<any>();
  page: number = 1;
  pageInvoice: number = 1;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  subscription: Subscription;
  tableActions: TableAction[] = [];
  userAuthenticated: UserModel = new UserModel();
  componentTableSelection = CustomTableSelectComponent;
  componentTaxesModal = InvoiceCashReceiptRetentionModalComponent;

  constructor(private invoiceCashReceiptService: InvoiceCashReceiptService,
    private invoiceService: InvoiceService,
    private optionWindowService: OptionWindowService,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService) { }

  async ngOnInit(): Promise<void> {
    this.getPermissionsForUserByWindow();
    await this.getColumns();
    await this.getColumnsInvoice();
    this.tableActions = this.getDefaultActions();

    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeInvoice(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeInvoice(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const cashReceiptModel = changes["cashReceiptModel"];
    if (cashReceiptModel && !cashReceiptModel.firstChange) {
      this.getFormView(false);
      this.getInvoiceCashs();
      this.invoiceCashReceiptModel = new InvoiceCashReceiptModel();
    }

    const disabledDetail = changes["disabledDetail"];
    if (disabledDetail && !disabledDetail.firstChange) {
      this.tableActions = this.getDefaultActions();
    }
  }

  async deleteInvoiceCashReceipt(selectedIds: number[]) {
    if (selectedIds.length === 0) return;

    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para modificar recibos de caja. Comuníquese con el administrador del sistema.'
      );
      return;
    }

    const result = await Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea eliminar el detalle del recibo de caja?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.invoiceCashReceiptService.deleteSomeInvoiceCashReceipt(selectedIds));
        this.toastHandlerService.showToast(
          'success',
          'El detalle del recibo de caja fue eliminado exitosamente.'
        );
        this.invoiceCashReceiptModel = new InvoiceCashReceiptModel();
        this.clearSelectionTrigger++;
        this.getFormView(false);
        this.getInvoiceCashs();
      } catch (error) {
        console.error('Error al eliminar el detalle del recibo de caja.', error);
      }
    }
  }

  async getColumns() {
    try {
      this.detailHeader = await firstValueFrom(this.invoiceCashReceiptService.getColumnsForCaptureTable());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getColumnsInvoice() {
    try {
      if (this.headerInvoice.length != 0) return;
      this.headerInvoice = await firstValueFrom(this.invoiceCashReceiptService.getColumnsForInvoiceSelection(this.isChargeAccount));
      this.updateInputs();
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de facturas o cuantas de cobro.', error);
    }
  }

  getDefaultActions(): TableAction[] {
    if (this.disabledDetail) {
      return [
        {
          label: 'Impuestos',
          icon: 'pi pi-receipt',
          action: 'taxes'
        }
      ];
    } else {
      return [
        {
          label: 'Editar',
          icon: 'pi pi-pencil',
          action: 'edit'
        },
        {
          label: 'Impuestos',
          icon: 'pi pi-receipt',
          action: 'taxes'
        }
      ];
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getListInvoicesForSelection() {
    try {
      this.dataInvoice = await firstValueFrom(this.invoiceCashReceiptService.getListInvoicesForSelection(
        this.cashReceiptModel.cashReceiptId, this.pageInvoice, this.limitInvoice, this.columnSortInvoice, this.ascendantInvoice, this.filtersInvoice
      ));
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de las facturas o cuentas de cobro', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0)));
    if (this.isChargeAccount) {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.CashReceiptChargeAccount));
    } else {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.CashReceipt));
    }
  }

  async getInvoiceCashs() {
    try {
      this.detailData = await firstValueFrom(this.invoiceCashReceiptService.getInvoiceCashsForCaptureTable(
        this.page, this.limit, this.columnSort, this.ascendant, this.cashReceiptModel.cashReceiptId, this.cashReceiptModel.isChargeAccount, this.filters
      ));
      this.updateInputs();
      this.quantityDetails.emit(this.detailData.items.length);
    } catch (error) {
      console.error('Error al buscar los detalles del recibo de caja.', error);
    }
  }

  async handleSelectedItem(selectedItem: any) {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para la edición de recibos de caja. Comuníquese con el administrador del sistema.'
      );
      return;
    }
    const textMessage = selectedItem.length === 1
      ? '¿Realmente desea agregar el documento seleccionado?'
      : '¿Realmente desea agregar los documentos seleccionados?';
    Swal.fire({
      title: 'Atención',
      text: textMessage,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (selectedItem.length == 1) {
          const invoiceId = parseInt(selectedItem[0]?.invoiceId);
          const invoice = await firstValueFrom(this.invoiceService.getInvoiceById(invoiceId));
          if (!invoice) {
            this.toastHandlerService.showToast('error', 'No se encontró la factura o cuenta de cobro seleccionada.');
            return;
          }
          const response = await firstValueFrom(
            this.invoiceCashReceiptService.getInvoiceCashReceiptByKeys(this.cashReceiptModel.cashReceiptId, invoiceId)
          );
          if (response && response.invoiceCashReceiptId !== 0) {
            this.invoiceCashReceiptModel = response;
          } else {
            this.invoiceCashReceiptModel = new InvoiceCashReceiptModel();
            this.invoiceCashReceiptModel.cashReceiptId = this.cashReceiptModel.cashReceiptId;
            this.invoiceCashReceiptModel.invoiceId = invoiceId;
            this.invoiceCashReceiptModel.consecutiveInvoice = invoice.consecutive;
            this.invoiceCashReceiptModel.residueValueInvoice = invoice.residueValue;
            this.invoiceCashReceiptModel.paidValue = invoice.residueValue;
          }
          this.clearSelectionTrigger++;
          this.getFormView(true);
        } else {
          const invoiceIds = selectedItem.map((element: { invoiceId: number; }) => element.invoiceId);
          try {
            await firstValueFrom(this.invoiceCashReceiptService.createSomeAsync(invoiceIds, this.cashReceiptModel.cashReceiptId));
          } catch (error) {
            console.error('Error al agregar los documentos.', error);
          }
          this.toastHandlerService.showToast('success', 'Los documentos fueron agregados exitosamente', '');
          this.getInvoiceCashs();
        }
      }
    });
  }

  async onAction(event: { action: string, item?: InvoiceCashReceiptCaptureTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit') {
      const response = await firstValueFrom(this.invoiceCashReceiptService.getInvoiceCashReceiptById(event.item!.id));
      if (response) {
        response.consecutiveInvoice = event.item!.documentConsecutive;
        response.residueValueInvoice = event.item!.residueValue;
        this.invoiceCashReceiptModel = response;
      }
      this.getFormView(true);
    }
    if (event.action === 'taxes') {
      this.invoiceCashReceiptId = event.item?.invoiceCashReceiptId || 0;
      this.updateInputs();
      this.openTaxesModal();
      this.getFormView(false);
    }
    if (event.action === 'bulk-delete' && event.selectedItems) {
      this.deleteInvoiceCashReceipt(event.selectedItems);
    }
  }

  async onExport() {
    if (this.detailData.totalItems === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'No hay datos para exportar.'
      );
      return;
    }
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.Exportar)) {
      try {
        const response = await firstValueFrom(this.invoiceCashReceiptService.exportInvoiceCashReceiptDetailsConsultation(
          this.filters, this.columnSort, this.ascendant, this.cashReceiptModel.cashReceiptId, this.cashReceiptModel.isChargeAccount
        ));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Detalles del Recibo de Caja.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar los detalles del Recibo de Caja.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para exportar detalles de Recibos de Caja, comuniquese con el administrador del sistema.'
      );
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onFilterChangeInvoice(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersInvoice = this.removeDuplicates(filters);
    this.filtersInvoice.forEach((filter: any) => this.processFilterInvoice(filter));
    this.updateInputs();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getInvoiceCashs();
  }

  async onPageChangeInvoice(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageInvoice = event.page;
    this.limitInvoice = event.pageSize;
    this.columnSortInvoice = event.sortField || null;
    this.ascendantInvoice = event.sortOrder === 1;
    await this.getListInvoicesForSelection();
  }

  async openInvoiceSelectionModal() {
    this.filtersInvoice = [];
    this.updateInputs();
    await this.getListInvoicesForSelection();
    this.invoiceSelectionModalComponent && this.invoiceSelectionModalComponent.show();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  openTaxesModal() {
    if (this.cashReceiptModel.cashReceiptId !== 0 && this.cashReceiptModel.cashReceiptId != null) {
      this.taxesModalComponent && this.taxesModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un Recibo de Caja.'
      );
    }
  }

  processFilterInvoice(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersInvoice = this.filtersInvoice.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersInvoice.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  reloadList(reload: boolean) {
    if (reload) {
      this.getInvoiceCashs();
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  updateInputs() {
    this.inputsForInvoicesSelection$.next({
      headers: this.headerInvoice,
      data: this.dataInvoice,
      showCheckbox: true,
      showRecover: false,
      isMultipleSelect: true,
      filters: this.filtersInvoice,
    });
    this.inputsForTaxesModals$.next({
      invoiceCashReceiptId: this.invoiceCashReceiptId,
      permissionUpdatable: this.permissionUpdatable,
      disabledForm: this.disabledDetail
    });
  }

}
